import { postRequest } from '../../../shared/utils';

export async function getNpiHtzDetails(htz, screenGridId, returnColumns) {
  const body = {
    columns: returnColumns,
    screenGridId,
    schema: 'npi',
    table: 'v_pomon_htz_details',
    key: 'npi_htz',
    value: htz,
  };
  const { data, errors } = await postRequest('/api/records', body);
  if (errors) {
    return { errors };
  }

  return data;
}
